import ListingDiscounts from '../../ListingDiscounts/ListingDiscounts';
import { getDiscountExtension } from '../../../helpers/discountExtension';
import billDetailsHelpers from '../../../helpers/billDetailsHelper';
import { checkAvailability } from '../../../actions/checkAvailability';
import { getSpecialPricingData } from '../../../actions/Listing/getSpecialPricingData';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import { injectIntl, FormattedMessage } from 'react-intl';

import DateRange from '../DateRange';
import BillDetails from './BillDetails';
import BookingButton from './BookingButton';
import moment from 'moment'
import TimeField from '../TimeField';
import BookingOptions from '../BookingOptions/BookingOptions';

import messages from '../../../locale/jsonMessages';
import { bookingProcess } from '../../../actions/booking/bookingProcess';
import { generateTimes } from '../../../helpers/formatting';
import {
  getBookableOptions, resolveSelection, toOptionInputs, isDeliveryLocationValid,
} from '../../../helpers/bookingOptionsPresentation';

import cs from '../../../components/commonStyle.css';
import s from './Calendar.css';

class BookingForm extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    listingOptions: PropTypes.array,
    currency: PropTypes.string,
    monthlyDiscount: PropTypes.number,
    weeklyDiscount: PropTypes.number,
    minDay: PropTypes.number,
    maxDay: PropTypes.number,
    maxDaysNotice: PropTypes.string,
    loading: PropTypes.bool,
    availability: PropTypes.bool,
    maximumStay: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    blockedDates: PropTypes.array,
    isHost: PropTypes.bool.isRequired,
    guests: PropTypes.number,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userBanStatus: PropTypes.number,
    })
  };

  static defaultProps = {
    blockedDates: [],
    availability: true,
    maximumStay: false,
    minimumStay: false,
    startDate: null,
    endDate: null,
    guests: 1,
    personCapacity: 0,
  };

  componentDidMount() {
    // Options chosen before a login redirect come back as ids in the URL; nothing is selected otherwise.
    const { URLOptionIds, listingOptions, change } = this.props;
    if (Array.isArray(URLOptionIds) && URLOptionIds.length > 0) {
      const bookable = getBookableOptions(listingOptions).map((option) => Number(option.id));
      change('selectedOptions', URLOptionIds.filter((id) => bookable.includes(id)));
    }
  }


  renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;
    const rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</option>);
    }
    return rows;
  }

  handleToggleOption = (optionId, checked) => {
    const { change, selectedOptions } = this.props;
    const current = (selectedOptions || []).map(Number);
    const next = checked ? Array.from(new Set([...current, optionId])) : current.filter((id) => id !== optionId);
    change('selectedOptions', next);
  }

  handleDeliveryLocation = (value) => {
    this.props.change('deliveryLocation', value);
  }

  handleExtendDates = async (targetEnd) => {
    const { id, startDate, endDate, startTime, endTime, weeklyDiscount, monthlyDiscount,
      blockedDates, maxDay, maxDaysNotice, change, getSpecialPricingData, checkAvailability, minDay } = this.props;
    const extension = getDiscountExtension({ startDate, endDate, startTime, endTime,
      weeklyDiscount, monthlyDiscount, blockedDates, maxDay, maxDaysNotice });
    if (!extension || !extension.targetEnd.isSame(targetEnd, 'day')) return;
    change('endDate', targetEnd);
    await Promise.all([
      getSpecialPricingData(id, moment(startDate).format('YYYY-MM-DD'), targetEnd.format('YYYY-MM-DD')),
      checkAvailability(id, moment(startDate).format('YYYY-MM-DD'), targetEnd.format('YYYY-MM-DD'),
        maxDay, startTime, endTime, minDay)
    ]);
  }
  render() {
    const { formatMessage } = this.props.intl;
    const { id, basePrice, currency, isHost, bookingType, isHostServiceEligible } = this.props;
    const { monthlyDiscount, weeklyDiscount, minDay, maxDay, maxDaysNotice, securityDeposit } = this.props;
    const { isLoading, availability, maximumStay, guests, startDate, endDate, account, blockedDates, minimumStay } = this.props;
    const { bookingProcess, serviceFees, base, rates, bookingLoading, startTime, endTime } = this.props;
    const { bookingLoader, listingOptions, selectedOptions, deliveryLocation } = this.props;
    const { promoValue, deductionType, promoId, description, promoCode, dynamicPromoCode } = this.props;
    const isDateChosen = startDate != null && endDate != null || false;
    let userBanStatusValue, isTimeChosen;
    let momentStartDate, momentEndDate, dayDifference, isDisabled = false, isValue = true;
    let isToday = false, startTimeLookup, endTimeLookup;

    if (account) {
      const { account: { userBanStatus } } = this.props;
      userBanStatusValue = userBanStatus;
    }

    // Bookable options only; a selection that is no longer offered is ignored (nothing is selected by default).
    const bookableOptions = getBookableOptions(listingOptions);
    const { items: selectedItems } = resolveSelection(
      bookableOptions,
      (selectedOptions || []).map((optionId) => ({ optionId, userInput: deliveryLocation }))
    );
    const isDeliverySelected = selectedItems.some((item) => item.code === 'delivery');
    const isLocationMissing = isDeliverySelected && !isDeliveryLocationValid(deliveryLocation);

    momentStartDate = moment(startDate);
    momentEndDate = moment(endDate);
    dayDifference = momentEndDate.diff(momentStartDate, 'days');

    isTimeChosen = isNaN(startTime) || isNaN(endTime) ? false : true;

    if ((startTime >= endTime) && dayDifference == 0) {
      isValue = false;
      isDisabled = true;
    }
    if (!isTimeChosen) {
      isDisabled = true;
    } else if (!isDateChosen) {
      isDisabled = true;
    }
    if (isLocationMissing) {
      isDisabled = true;
    }

    startTimeLookup = generateTimes(0, 1410, isToday, this.props.locale);
    endTimeLookup = generateTimes(0, 0, false, this.props.locale);

    if (momentStartDate) {
      isToday = moment(moment(momentStartDate)).isSame(moment(), 'day');
      startTimeLookup = generateTimes(0, 1410, isToday, this.props.locale);
    }

    if (momentEndDate) {
      isToday = moment(moment(momentEndDate)).isSame(moment(), 'day');
      endTimeLookup = generateTimes(0, 0, isToday, this.props.locale);
    }

    const extension = isDateChosen && isTimeChosen && isValue && availability && !isLoading && !bookingLoader
      ? getDiscountExtension({ weeklyDiscount, monthlyDiscount, startDate, endDate,
        startTime, endTime, blockedDates, maxDay, maxDaysNotice }) : null;
    let additionalSavings = null, projectedSavings = null;
    if (extension) {
      const pricing = { basePrice, weeklyDiscount, monthlyDiscount, serviceFees: null,
        base, rates, currency, options: [], securityDeposit: 0, promoValue: 0 };
      const current = billDetailsHelpers({ ...pricing, startDate, endDate, startTime, endTime,
        specialPricing: this.props.specialPricing || [] });
      const projected = billDetailsHelpers({ ...pricing, startDate, endDate: extension.targetEnd,
        startTime, endTime, specialPricing: blockedDates.filter(day => day.calendarStatus === 'available' && Number(day.isSpecialPrice) > 0) });
      if (Number.isFinite(projected.discount) && projected.discount > 0) {
        projectedSavings = projected.discount;
        additionalSavings = projected.discount - (Number.isFinite(current.discount) ? current.discount : 0);
      }
    }

    return (
      <Form>
        {!isDateChosen && <ListingDiscounts variant="summary"
          weeklyDiscount={weeklyDiscount} monthlyDiscount={monthlyDiscount}
          startDate={startDate} endDate={endDate} startTime={startTime} endTime={endTime} />}
        <FormGroup className={cs.spaceBottom4}>
          <label className='commonLabelText'>
            <FormattedMessage {...messages.dates} /><sub className='isRequiredStar'>*</sub>
          </label>
          <span className={cx('viewListingDate')}>
            <DateRange
              listId={id}
              minimumNights={minDay}
              maximumNights={maxDay}
              blockedDates={blockedDates}
              formName={'BookingForm'}
              maxDaysNotice={maxDaysNotice}
              startTime={startTime}
              endTime={endTime}
            />
          </span>
        </FormGroup>
        <FormGroup className={cs.spaceBottom4}>
          <label className='commonLabelText'>{formatMessage(messages.startLabel)}<sub className='isRequiredStar'>*</sub></label>
          <div className={s.displayGrid}>
            <TimeField
              name={"startTime"}
              className='commonSelectField'
              TimeLookup={startTimeLookup}
              formName={"BookingForm"}
              label={formatMessage(messages.tripStart)}
              listId={id}
              startDate={startDate}
              endDate={endDate}
              startTime={startTime}
              endTime={endTime}
              maximumNights={maxDay}
              value={startTime}
              minimumNights={minDay}
            />
            <TimeField
              name={"endTime"}
              className='commonSelectField'
              TimeLookup={endTimeLookup}
              formName={"BookingForm"}
              label={formatMessage(messages.tripEnd)}
              listId={id}
              startDate={startDate}
              endDate={endDate}
              startTime={startTime}
              endTime={endTime}
              maximumNights={maxDay}
              value={endTime}
              minimumNights={minDay}
            />
          </div>
        </FormGroup>
        <BookingOptions
          options={bookableOptions}
          selectedIds={selectedItems.map((item) => Number(item.id))}
          onToggle={this.handleToggleOption}
          deliveryLocation={deliveryLocation || ''}
          onLocationChange={this.handleDeliveryLocation}
          currency={currency}
        />
        <FormGroup>
          {
            !isLoading && maximumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumStay} /> {maxDay} {maxDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }
          {
            !isLoading && minimumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumStayText} /> {minDay} {minDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }

          {
            !isLoading && !availability && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.hostErrorMessage2} />
              </p>
            </div>
          }
          {
            isTimeChosen && !isValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}><FormattedMessage {...messages.youMustChooseTime} /></p>
            </div>
          }
        </FormGroup>
        {
          !bookingLoader && !maximumStay && !minimumStay && availability && isDateChosen && !userBanStatusValue && isTimeChosen && isValue
          && <BillDetails
            basePrice={basePrice}
            options={selectedItems}
            currency={currency}
            monthlyDiscount={monthlyDiscount}
            weeklyDiscount={weeklyDiscount}
            startDate={startDate}
            endDate={endDate}
            serviceFees={serviceFees}
            base={base}
            rates={rates}
            securityDeposit={securityDeposit}
            promoValue={promoValue}
            deductionType={deductionType}
            promoCode={promoCode}
            promoId={promoId}
            description={description}
            dynamicPromoCode={dynamicPromoCode}
          />
        }
        {extension && <ListingDiscounts variant="next"
          weeklyDiscount={weeklyDiscount} monthlyDiscount={monthlyDiscount}
          startDate={startDate} endDate={endDate} startTime={startTime} endTime={endTime}
          additionalDays={extension.additionalDays} additionalSavings={additionalSavings}
          projectedSavings={projectedSavings} currency={currency}
          onExtend={() => this.handleExtendDates(extension.targetEnd)} />}
        <BookingButton
          listId={id}
          startDate={startDate}
          endDate={endDate}
          guests={!isNaN(guests) ? guests : 1}
          bookingProcess={bookingProcess}
          availability={availability}
          isDateChosen={isDateChosen}
          userBanStatus={userBanStatusValue}
          basePrice={basePrice}
          isHost={isHost}
          bookingType={bookingType}
          bookingLoading={bookingLoading}
          maximumStay={maximumStay}
          isDisabled={isDisabled}
          startTime={startTime}
          endTime={endTime}
          options={toOptionInputs(selectedItems)}
          isHostServiceEligible={isHostServiceEligible}
          promoCode={promoCode}
        />
      </Form>
    );
  }
}
BookingForm = reduxForm({
  form: 'BookingForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(BookingForm);

const selector = formValueSelector('BookingForm');

const mapState = state => ({
  isLoading: state?.viewListing?.isLoading,
  availability: state?.viewListing?.availability,
  maximumStay: state?.viewListing?.maximumStay,
  minimumStay: state?.viewListing?.minimumStay,
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  guests: Number(selector(state, 'guests')),
  account: state?.account?.data,
  serviceFees: state?.book?.serviceFees,
  base: state?.currency?.base,
  rates: state?.currency?.rates,
  bookingLoading: state?.book?.bookingLoading,
  startTime: Number(selector(state, 'startTime')),
  endTime: Number(selector(state, 'endTime')),
  selectedOptions: selector(state, 'selectedOptions'),
  deliveryLocation: selector(state, 'deliveryLocation'),
  locale: state.intl.locale,
  isHostServiceEligible: selector(state, 'isHostServiceEligible'),
  promoCode: selector(state, 'promoCode'),
  promoValue: selector(state, 'promoValue'),
  deductionType: selector(state, 'deductionType'),
  promoId: selector(state, 'promoId'),
  description: selector(state, 'description'),
  dynamicPromoCode: selector(state, 'dynamicPromoCode'),
  specialPricing: state?.viewListing?.specialPricing
});
const mapDispatch = {
  bookingProcess,
  getSpecialPricingData,
  checkAvailability,
};
export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(BookingForm)));
